import React from "react";
import { motion } from "framer-motion";

const HealthAlertsGraph: React.FC = () => {
    return (
        <div className="space-y-3" dir="rtl">
            <div>
                <h4 className="font-medium text-[#002B5C] mb-1">هشدارهای فعال</h4>
                <div className="p-3 bg-[#FF4F00]/10 rounded-[16px] mb-3 border border-[#FF4F00]/20">
                    <div className="flex items-start">
                        <svg className="w-5 h-5 text-[#FF4F00] mt-0.5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                            ></path>
                        </svg>
                        <div>
                            <h5 className="font-medium text-[#FF4F00] mb-1">ضربان قلب نامنظم</h5>
                            <p className="text-sm text-[#4A5568]">در ۲۴ ساعت گذشته، ۳ مورد ضربان قلب نامنظم شناسایی شده است.</p>
                            <div className="mt-2 text-xs text-[#9EA3A9]">آخرین رویداد: ۲ ساعت پیش</div>
                        </div>
                    </div>
                </div>

                <h4 className="font-medium text-[#002B5C] mb-1">توصیه پزشکی</h4>
                <div className="p-3 bg-[#ECEFF1] rounded-[16px] shadow-[0_2px_8px_rgba(0,0,0,0.02)] mb-3">
                    <p className="text-sm text-[#4A5568]">اگر این هشدار ادامه داشت، با پزشک خود مشورت کنید. استرس و کافئین می‌تواند باعث ضربان نامنظم شود.</p>
                </div>

                <h4 className="font-medium text-[#002B5C] mb-1">رویدادهای اخیر</h4>
                <div className="h-20 bg-[#ECEFF1] rounded-[16px] p-3 flex items-end shadow-[0_2px_8px_rgba(0,0,0,0.02)]">
                    {[...Array(24)].map((_, i) => {
                        const hasAlert = [4, 10, 18].includes(i);
                        const height = hasAlert ? 80 : 20 + Math.random() * 10;
                        const color = hasAlert ? "bg-[#FF4F00]" : "bg-[#0072CE]";
                        return (
                            <motion.div
                                key={i}
                                className={`w-1.5 mx-0.5 rounded-t-[4px] ${color}`}
                                initial={{ height: 0 }}
                                animate={{ height: `${height}%` }}
                                transition={{
                                    duration: 0.2,
                                    delay: i * 0.03,
                                    ease: [0.4, 0.0, 0.2, 1],
                                }}
                            />
                        );
                    })}
                </div>
                <div className="flex justify-between text-xs text-[#9EA3A9] mt-1">
                    <span>۲۴ ساعت گذشته</span>
                    <span>اکنون</span>
                </div>
            </div>
        </div>
    );
};

export default HealthAlertsGraph;
